export enum AssetFilterTestId {
    DROPDOWN_SELECT_PREFIX = "asset-select-",
    FILTERS_ROW = "asset-filters-row",
    CLEAR_FILTERS_BTN = "clear-filters"
}